import { render, staticRenderFns } from "./PhoneNumberDisplay.vue?vue&type=template&id=5123fe6c&scoped=true&"
import script from "./PhoneNumberDisplay.vue?vue&type=script&lang=js&"
export * from "./PhoneNumberDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5123fe6c",
  null
  
)

export default component.exports